import { TabView } from "primereact/tabview";
import * as React from "react";
import { useEffect, useState } from "react";

const PrwcTabView = (props: any) => {
  const { activeIndex = [0] } = props;
  const [activeTab, setActiveTab] = useState(activeIndex);

  useEffect(() => {
    setActiveTab(activeIndex);
  }, [activeIndex]);

  const handleTabChange = (activeTabs: any) => {
    props.changeActiveTab(activeTabs);
  };

  return (
    <TabView
      activeIndex={activeTab}
      onTabChange={(e) => handleTabChange(e.index)}
    >
      {props.children}
    </TabView>
  );
};

export default PrwcTabView;
